// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyD3zrzULl2c01PysgetfX1IJ2RMc0WZP-w',
    authDomain: 'gom-points-calculator.firebaseapp.com',
    databaseURL: 'https://gom-points-calculator.firebaseio.com',
    projectId: 'gom-points-calculator',
    storageBucket: 'gom-points-calculator.appspot.com',
    messagingSenderId: '897464124179',
    appId: '1:897464124179:web:e9a970376a2e01b58a50e6',
    measurementId: 'G-EL6RPGZH31'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
